import { Component, computed, Inject, input, OnInit, signal } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { TranslateService } from '../../i18n/translate.service';

@Component({
  selector: 'title-dialog',
  templateUrl: './title-dialog.component.html',
  styles: ``,
  providers: [
    {
      provide: 'i18n-label',
      useValue: 'AfdelingListComponent'
    }
  ]

})
export class TitleDialogComponent  extends DialogContentBase {

  constructor(public dialog: DialogRef, private translateService: TranslateService, @Inject('i18n-label') private i18nLabel: any) {
    super(dialog);
  }

  public title = "Nieuwe Afdeling";
  public maxLength = 255;

  public dialogNameKey = signal("Afdeling Naam");
  public dialogNameTranslated = computed(() => {
    let translateRepo = this.translateService.translateSignal();
    return this.translateService.getTranslationSync(translateRepo, this.i18nLabel, this.dialogNameKey(), this.dialogNameKey());
  });

  public onCancelAction(): void {
    this.dialog.close({ text: "Cancel" });
  }

  public onConfirmAction(): void {
    this.dialog.close({ text: "Submit", naam: this.title });
  }
}
